import { http } from '@/api/client/httpClient';
import type { PagedResult } from '@/api/types/abp';

export interface TerminalDataSourceDto {
  id: number;
  connectionId: string;
  name: string;
  server: string | null;
  accountLogin: string | null;
  password: string | null;
  enabled: boolean;
  connectionType: string;
  hasPendingRequest: boolean;
  pendingName: string | null;
}

export interface TerminalFilterInput {
  connectionType?: string;
  name?: string;
  skipCount?: number;
  maxResultCount?: number;
  sorting?: string;
  draw?: number;
}

export interface TerminalRequestHistoryDto {
  id: string;
  dataSourceId: number | null;
  terminalName: string;
  requestType: string;
  status: string;
  requestedBy: string;
  requestDate: string;
  approvalDate: string | null;
}

export interface DataSourceAddRequestInput {
  connectionType: number;
  name?: string;
  server?: string;
  accountLogin?: string;
  password?: string;
  enabled: boolean;
}

export interface DataSourceEditRequestInput {
  dataSourceId: number;
  name?: string;
  server?: string;
  accountLogin?: string;
  password?: string;
  enabled?: boolean;
}

const BASE = '/api/app/terminal-management';

export const terminalManagementApi = {
  getTerminals: (input: TerminalFilterInput) =>
    http.get<PagedResult<TerminalDataSourceDto>>(`${BASE}/terminals`, { params: input }).then((r) => r.data),
  getRequestHistory: (input: { skipCount?: number; maxResultCount?: number; sorting?: string; draw?: number }) =>
    http.get<PagedResult<TerminalRequestHistoryDto>>(`${BASE}/request-history`, { params: input }).then((r) => r.data),
  requestNew: (input: DataSourceAddRequestInput) => http.post(`${BASE}/request-new`, input).then((r) => r.data),
  requestEdit: (input: DataSourceEditRequestInput) => http.post(`${BASE}/request-edit`, input).then((r) => r.data),
};
